import clsx from 'clsx'
import React, { useState } from 'react'

import { TProduct } from '@/shared/types/product-types'
import { Image } from '@/shared/ui/Image'

import styles from './CatalogItemImagesSlider.module.scss'

type ItemImageProps = {
	title: TProduct[`TITLE`]
	mainSrc: TProduct[`IMAGE`]
	restSrces: TProduct[`IMAGES`]
	isHovered: boolean
}

const IMAGES_SIZE = 160

/** Image component for product mini-card
 *
 * @param props
 * @param props.title - product title
 * @param props.mainSrc - main product's image
 * @param props.restSrces - product's images array
 * @param props.isHovered
 * */
export const CatalogItemImagesSlider = ({ title, restSrces = [], isHovered, mainSrc }: ItemImageProps): JSX.Element => {
	const [activeImage, setActiveImage] = useState<number>(0)
	const indexImage = mainSrc ? mainSrc : `/product-image-placeholder.jpeg`
	const activeDotIndex = isHovered ? activeImage : 0
	return (
		<div className={styles.catalogItemImagesSlider}>
			{(!isHovered || !restSrces?.length) && (
				<div className={styles.mainSlide}>
					<Image
						src={indexImage}
						width={IMAGES_SIZE}
						height={IMAGES_SIZE}
						alt={`Изображение товара «${title}»`}
						data-label="mainImage"
						placeholder="blur"
					/>
				</div>
			)}
			{isHovered && !!restSrces?.length && (
				<div className={styles.inner}>
					<div className={styles.invisiblePanel}>
						{restSrces.map((image, index) => (
							<span key={image} onFocus={() => setActiveImage(index)} onMouseOver={() => setActiveImage(index)} />
						))}
					</div>

					<div className={styles.items}>
						{restSrces.map((image, index) => (
							<div key={image} className={clsx(styles.item, index === activeImage && styles.itemActive)}>
								<Image
									src={image}
									width={IMAGES_SIZE}
									height={IMAGES_SIZE}
									alt={`Изображение товара «${title}» № ${index}${2}`}
									placeholder="blur"
								/>
							</div>
						))}
					</div>
				</div>
			)}
			{restSrces.length > 1 && (
				<div className={styles.dots}>
					{restSrces.map(
						(image, index) =>
							index <= 3 && (
								<span key={image} className={clsx(styles.dot, index === activeDotIndex && styles.dotActive)} />
							)
					)}
				</div>
			)}
		</div>
	)
}
